<template>
    <div class="modal fade" id="cobrancaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">O que deseja fazer com o boleto?</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" @click="enviarPorEmail">Enviar por Email</button>
                    <button type="button" class="btn btn-primary" @click="mostrarPdf">Abrir PDF</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
export default {
    data() {
        return {
            boleto: null
        }
    },

    methods: {
        abrir(params) {
            this.boleto = params;
            $('#cobrancaModal').modal('show');
        },
        close() {
            $('#cobrancaModal').modal('hide');
        },
        mostrarPdf() {
            this.close();
            this.$util.abrirPdf(this.boleto.pdf);
        },
        enviarPorEmail() {
            this.$util.load(this, {
                service: 'banco_brasil_helper',
                func: 'enviar_boleto_por_email',
                parms: {
                    id_fatura: this.boleto.id_fatura,
                },
                loadTo: res => {
                    this.close();
                    if (res.status_code == 200) {
                        this.$toast.add({
                            severity: "success",
                            summary: "Enviado",
                            detail: res.msg,
                            life: 5000
                        });
                    }
                }
            });
        }
    }
} 
</script>

<style scoped>
.modal-dialog-total {
    max-width: 100%;
    width: 100%;
    margin: 0;
    height: 100%;
}

.modal-content-total {
    height: 100%;
    border-radius: 0;
}
</style>